document.addEventListener("DOMContentLoaded", function () {
  const productsContainer = document.querySelector("#filter-output");

  if (!productsContainer) {
    return;
  }

  // Handle hover using mouseover + checking relatedTarget to simulate mouseenter delegation
  productsContainer.addEventListener("mouseover", function (e) {
    const option = e.target.closest(".product-color-option");
    if (!option || !productsContainer.contains(option)) return;

    if (
      e.relatedTarget &&
      (option === e.relatedTarget || option.contains(e.relatedTarget))
    )
      return;

    switchVariation(option);
  });

  // Handle click for mobile/touch
  productsContainer.addEventListener("click", function (e) {
    const option = e.target.closest(".product-color-option");
    if (!option || !productsContainer.contains(option)) return;

    e.preventDefault();
    e.stopPropagation();
    switchVariation(option);
  });

  // Switch variation function
  function switchVariation(option) {
    const card = option.closest(".product-wrap");
    if (!card) return;

    const variationId = option.getAttribute("data-variation-id");
    if (!variationId) return;

    const hoverImages = card.querySelectorAll(".product-hover-img");
    if (!hoverImages.length) return;

    hoverImages.forEach(function (img) {
      if (img.getAttribute("data-variation-id") === variationId) {
        img.classList.remove("d-none");
      } else {
        img.classList.add("d-none");
      }
    });
  }
});
